import React, { useState, useEffect } from 'react';
import WellnessStore from '../DataRepo/WellnessStore';
import { IconButton, Button } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import lockimg from '../Assets/images/lock_icon.png'
import { CircularProgress } from '@mui/material';
import loadingimg from '../Assets/images/loading image 1.png'
import yogalandingimg from '../Assets/images/yoga.png'
import SubscriptionStore from '../DataRepo/SubscriptionStore';
import { getUserDetails } from '../Auth/AuthUtil';
import AppointmentStore from '../DataRepo/AppointmentStore';

function YogaPage() {
    const navigate = useNavigate()
    const userDetails = getUserDetails()
    const { Subscriptiondetails, Subscriptiondetailsloading, getSubscriptiondetails, isSubscribed } = SubscriptionStore()
    const { getYoga, selectedYogas, unselectedYogas, isYogaLoading } = WellnessStore();
    const { Appointments, isAppointmentsLoading, getAppointments } = AppointmentStore()

    useEffect(() => {
        getYoga()
        getSubscriptiondetails()
        getAppointments(userDetails?.UID)
    }, [])

    const filterAppointments = Appointments.filter(e => e.appointment_status === 'upcoming' || e.appointment_status === 'confirmed').sort((a, b) => {
        const dateA = a?.timestamp ? new Date(Number(a?.timestamp)) : new Date(0);
        const dateB = b?.timestamp ? new Date(Number(b?.timestamp)) : new Date(0);
        return dateB - dateA;
    });

    return <div className='All-products-section-main'>
        <nav className='flex flex-row p-2 items-center justify-between'>
            <div className='flex flex-row items-center'>
                <IconButton onClick={() => navigate(-1)}>
                    <ChevronLeft />
                </IconButton>
                <p className='mb-0'>Yoga</p>
            </div>
        </nav>
        {
            isYogaLoading ? <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100vw", height: '100vh' }}>
                <div style={{ position: "relative", width: "10rem", height: "10rem" }}>
                    <CircularProgress style={{ width: "100%", height: "100%", color: "#DA6E0B" }} thickness={1} />
                    <div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <img src={loadingimg} style={{ width: "80%", height: "80%" }} alt="Loading" />
                    </div>
                </div>
            </div>
                : <div className='Yoga-page-section'>
                    <div >
                        <div>
                            <img src={yogalandingimg}></img>
                        </div>
                        <div>
                            <p>Yoga</p>
                            <p>"Yoga is the journey of the self, through the self, to the self."</p>
                        </div>
                    </div>
                    <div className='Yoga-content-section'>


                        <div>
                            <p>Recommended for you</p>{
                                selectedYogas.length > 0 ?
                                    <div className='mt-2 Yogalist-container'>

                                        {selectedYogas.map((e, i) => {
                                            return <div className='yogacard' onClick={() => {
                                                navigate(`/yoga?id=${e?.id}`)
                                            }}>
                                                <div>
                                                    <p>{e?.title}</p>
                                                    <p>{e?.pose}</p>
                                                </div>
                                                <div>
                                                    <img src={e?.image} />
                                                </div>
                                            </div>
                                        })
                                        }
                                    </div> : 
                                    <div className='Unlockdiet mt-5'>

                                        <div>
                                            <img src={lockimg}></img>
                                        </div>

                                        <div style={{ width: "100%", maxWidth: "300px" }}>
                                            <Button
                                                style={{
                                                    width: "100%",
                                                    textTransform: "none",
                                                    backgroundColor: "#DA6E0B",
                                                    border: "none",
                                                    color: "#fdfdfd",
                                                    borderRadius: "5px",
                                                    fontFamily: "'Poppins', sans-serif",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    padding: "10px",
                                                }}

                                                onClick={() => {
                                                    {
                                                        isSubscribed ?
                                                            filterAppointments.length === 0 ?
                                                                navigate("/DoctorProfiles")
                                                                : navigate(`/Appointment?id=${filterAppointments[0]?.Appointment_id}&doc_id=${filterAppointments[0]?.doctor_uid}`)
                                                            : navigate("/PackageCheckout")
                                                    }
                                                }}

                                            >
                                                <p className='appointmentbooknowbtn'>
                                                    {
                                                        isSubscribed ?
                                                            filterAppointments.length === 0 ?
                                                                "Book your consultation"
                                                                : "Complete your consultation"
                                                            : 'Purchase our Wellness Package'
                                                    }
                                                </p>

                                            </Button>
                                        </div>

                                        <p>To get personalized Yoga recommendations</p>

                                        <div className="circle-container">
                                            <div className="circle" style={{ backgroundImage: `url(${yogalandingimg})` }}></div>
                                        </div>

                                    </div>
                            }
                        </div>

                        {unselectedYogas?.length > 0 &&
                            <div className='mt-5'>
                                <p>Explore other Yoga</p>
                                <div className='mt-2 Yogalist-container'>
                                    {
                                        unselectedYogas.map((e, i) => {
                                            return <div className='yogacard' onClick={() => {
                                                navigate(`/yoga?id=${e?.id}`)
                                            }}>
                                                <div>
                                                    <p>{e?.title}</p>
                                                    <p>{e?.pose}</p>
                                                </div>
                                                <div>
                                                    <img src={e?.image} />
                                                </div>
                                            </div>
                                        })
                                    }
                                </div>
                            </div>}
                    </div>
                </div>
        }
    </div>
}

export default YogaPage